<template>
  <div>
    <div v-if="poster_video && (showVideo || !poster_img)" :style="imgStyle"
         class="video-container">
      <fin-video-secure>
        <prismic-embed :field="poster_video"/>
      </fin-video-secure>
    </div>
    <v-img
      v-else-if="poster_img"
      :alt="alt"
      :src="url"
      :style="imgStyle">
      <v-layout slot="placeholder" align-center fill-height justify-center ma-0>
        <img :src="$fincraftBasics.img.loading"/>
      </v-layout>
    </v-img>
  </div>
</template>

<script>
export default {
  name: 'FinPostCover',
  props: {
    /**
     *  Post object from prismic
     */
    post: {
      required: true,
      type: Object,
    },
    /**
     * Css style for the header image or video container.
     */
    imgStyle: {
      default: 'display: inline-block; vertical-align: top; width: 100%; border: 1px solid rgba(200,200,200,0.5);',
    },
    /**
     *  Choosing if a video should be displayed or not.
     */
    showVideo: {
      type: Boolean,
    },
    /**
     *  Change the image resolution tor preview
     */
    highResolutionCover: {
      type: Boolean,
    },
  },
  computed: {
    alt() {
      return this.poster_img ? this.poster_img.alt : null
    },
    url() {
      return this.poster_img ? this.poster_img.url : null
    },
    poster_img() {
      let video = this.post.poster_img
      if (!this.highResolutionCover && video.preview) {
        video = video.preview
      }
      return video
    },
    poster_video() {
      return this.post.video
    },
  },
}
</script>

<style lang="scss" scoped>
.video-container {
  position: relative;
  padding-bottom: 56.25%;
  padding-top: 0;
  height: 0;
  overflow: hidden;
}

.video-container ::v-deep iframe,
.video-container ::v-deep object,
.video-container ::v-deep embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
